import { PlaceBasic, PlaceSourceSnapshot } from '../common/types';
import { getPlaceSourceData } from '../common/scorecardSourceData';
import { ScorecardIdentity } from './ScorecardIdentity';

const SOURCE_DISPLAY_NAMES: Record<string, string> = {
  google: 'Google',
  yelp: 'Yelp',
  bbb: 'BBB',
  dealerrater: 'DealerRater',
  opentable: 'OpenTable',
  tripadvisor: 'TripAdvisor',
  carscom: 'Cars.com',
  carfax: 'CarFax',
  edmunds: 'Edmunds',
  cargurus: 'CarGurus',
  booking: 'Booking.com',
  expedia: 'Expedia',
  golfpass: 'GolfPass',
};

export type ScorecardHeaderProps = {
  placeLetterGrade: string;
  placePercentile: number;
  place: PlaceBasic;
  snapshotMap?: Map<string, PlaceSourceSnapshot>;
  borderColor: string;
  source?: string | null;
};

export function ScorecardHeader(props: ScorecardHeaderProps) {
  const { placeLetterGrade, placePercentile, place, snapshotMap, borderColor, source } = props;
  const placeName = place.name;
  const placeAddress = place.address;

  // Normalize to lowercase before lookup. SOURCE_DISPLAY_NAMES and
  // getPlaceSourceData both key on lowercase ('yelp', 'bbb', …) but some
  // callers pass the formatted display name ('Yelp', 'BBB', …) as the
  // source prop. Without this normalization, every non-Google scorecard
  // rendered the wrong source's identity row: a Yelp scorecard would
  // show "4.3 ★ 842 Google reviews" because getPlaceSourceData fell
  // into the default Google branch.
  const sourceKey = (source ?? 'google').toLowerCase();
  const snapshot = snapshotMap?.get(sourceKey);
  const sourceName = SOURCE_DISPLAY_NAMES[sourceKey] ?? 'Google';

  const placeFallback = getPlaceSourceData(place, sourceKey);
  const rating = snapshot?.rating ?? placeFallback.rating;
  const reviewCount = snapshot?.review_count ?? placeFallback.reviewCount;
  const sourceLink = snapshot?.link ?? placeFallback.link;

  return (
    <ScorecardIdentity
      name={placeName}
      address={placeAddress}
      grade={placeLetterGrade}
      percentile={placePercentile}
      rating={rating}
      reviewCount={reviewCount}
      reviewLink={sourceLink}
      sourceName={sourceName}
      phoneNumber={place.phone_number}
      gradeBorderColor={borderColor}
    />
  );
}
